import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { AssignmentSectionQuestionQuery } from '@examdojo/assignment';
import { QuestionsWithAttemptStatuses } from '../question-selector/challenge-activity-question-selector.service';
import { ChallengeActivityQuestionSelectorUiComponent } from '../question-selector/challenge-activity-question-selector-ui.component';
import {
  ChallengeReviewQuestionSelectorService,
  ReviewQuestionsWithAttemptStatuses,
} from './challenge-review-question-selector.service';

@Component({
  selector: 'dojo-challenge-review-question-selector',
  standalone: true,
  imports: [ChallengeActivityQuestionSelectorUiComponent],
  template: `
    <dojo-challenge-activity-question-selector-ui
      [questions]="state.questions"
      [activeQuestionId]="state.activeQuestionId ?? null"
      (questionClick)="selectQuestion($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeReviewQuestionSelectorComponent {
  constructor(
    private readonly assignmentSectionQuestionQuery: AssignmentSectionQuestionQuery,
    private readonly challengeReviewQuestionSelectorService: ChallengeReviewQuestionSelectorService,
  ) {}

  readonly challengeActivityId = input.required<string>();

  readonly state = connectState({
    questions: this.challengeReviewQuestionSelectorService.questionsWithAttemptStatuses$,
    activeQuestionId: this.assignmentSectionQuestionQuery.activeQuestionId$,
  });

  selectQuestion(question: QuestionsWithAttemptStatuses) {
    this.challengeReviewQuestionSelectorService.selectQuestion(
      question as ReviewQuestionsWithAttemptStatuses,
      this.challengeActivityId(),
    );
  }
}
